var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	5946: {
		fallback: () => (() => (__webpack_require__(8949))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/head",

	},
	5244: {
		fallback: () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(4489))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	6467: {
		fallback: () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(4349))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	7252: {
		fallback: () => (() => (__webpack_require__(9774))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/router",

	},
	4137: {
		fallback: () => (() => (__webpack_require__(4518))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "react-dom",

	},
	4866: {
		fallback: () => (() => (__webpack_require__(4043))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/link",

	},
	5507: {
		fallback: () => (__webpack_require__.e(276).then(() => (() => (__webpack_require__(4276))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "next/script",

	},
	5999: {
		fallback: () => (__webpack_require__.e(604).then(() => (() => (__webpack_require__(6604))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "next/image",

	},
	3691: {
		fallback: () => (__webpack_require__.e(776).then(() => (() => (__webpack_require__(3776))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "next/dynamic",

	},
	6862: {
		fallback: () => (__webpack_require__.e(460).then(() => (() => (__webpack_require__(8460))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",

	},
	9743: {
		fallback: () => (__webpack_require__.e(949).then(() => (() => (__webpack_require__(9949))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",

	},
	4014: {
		fallback: () => (__webpack_require__.e(593).then(() => (() => (__webpack_require__(2181))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",

	},
	4886: {
		fallback: () => (__webpack_require__.e(27).then(() => (() => (__webpack_require__(27))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "@tanstack/react-query",

	},
	5657: {
		fallback: () => (__webpack_require__.e(174).then(() => (() => (__webpack_require__(1174))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "i18next",

	},
	2949: {
		fallback: () => (__webpack_require__.e(246).then(() => (() => (__webpack_require__(5246))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-i18next",

	},
	9087: {
		fallback: () => (__webpack_require__.e(181).then(() => (() => (__webpack_require__(6181))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-hook-form",

	},
	6072: {
		fallback: () => (__webpack_require__.e(178).then(() => (() => (__webpack_require__(1178))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-lazily",

	},
	540: {
		fallback: () => (() => (__webpack_require__(3239))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/compat/router",

	},
	8402: {
		fallback: () => (__webpack_require__.e(483).then(() => (() => (__webpack_require__(8483))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-tooltip",

	},
	6236: {
		fallback: () => (__webpack_require__.e(563).then(() => (() => (__webpack_require__(3563))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-phone-number-input",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [5946,5244,6467,7252,4137,4866,5507,5999,3691,6862,9743,5244,6467,4014,4137,4886,5657,2949,5946,5999,9087,6072,540,4866,5507,8402,6236];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"527": [
		5946,
		5244,
		6467,
		7252,
		4137,
		4866,
		5507,
		5999,
		3691,
		6862,
		9743
	],
	"636": [
		4886,
		5657,
		2949,
		5946,
		5999,
		9087,
		6072,
		540,
		4866,
		5507,
		8402,
		6236
	],
	"792": [
		5244,
		6467,
		4014,
		4137
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}